//=====================================================
//　医院情報：画像スライダー
//=====================================================

import { useContext } from "react";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import { CtxClinicInfo } from "../../utils/Contexts";

export function ClinicInfoSlider(){

    const cci = useContext(CtxClinicInfo);

    const [currentIdx, setCurrentIdx] = useState(0);

    const settings = {
        className: "clinic_info-img-slider",
        autoplay: true,
        autoplaySpeed: 4000,
        beforeChange: function(oldIndex:number, newIndex:number){
            setCurrentIdx(newIndex);
        }
    }

    return (
        <>
            {cci.data.imageUrls.length > 0 && 
                <div className="clinic_info-img-slider-wrapper">
                    <div className="clinic_info-img-slider-back">
                        {cci.data.imageUrls.map(function(img:string, idx:number){
                            let currentClass = "";
                            if (idx === currentIdx) {
                                currentClass = " is-current";
                            }
                            return (
                                <div key={idx} className={"clinic_info-img-slider-back-item" + currentClass} style={{backgroundImage: "url(" + img + ")"}}></div>
                            )
                        })}
                    </div>
                    <Slider {...settings}>
                        {cci.data.imageUrls.map(function(img:string, idx:number){
                            return (
                                <div key={idx}>
                                    <div className="clinic_info-img-slider-item" style={{backgroundImage: "url(" + img + ")"}}></div>
                                </div>
                            )
                        })}
                    </Slider>
                </div> 
            }
        </>
    )

}